<template>
  <div class="SoundControl"> 
    Listen simulation!
  </div> 
</template>

<script>

import gsap from "gsap"
import Description from "./Description.vue"

export default {

  name: 'SoundControl',
  components: { Description },
  mounted() {
    // console.log('SoundControl !');
    gsap.delayedCall(2, ()=>{
      this.$parent.completeListen()
    })
  },

}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.SoundControl
  position relative
  width 100%
  height 14%
  display flex
  align-items center
  justify-content center
  border-top 1px solid transparent
  border-bottom 1px solid transparent

</style>


